<template>
  <a-row id="createStep" style="width: 100%">
    <integrationNipModal
      ref="integrationNipModal"
      @handlerNipClose="handlerNipClose"
    />
    <a-form-model
      id="salesform"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="16" style="margin-bottom: 10px; font-weight: 700">
        <a-col :span="12">
          <div>
            {{ sale_record.invoiceAutoNumber + " " + sale_record.invoiceTitle }}
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item
            :label="$t('Spółka')"
            prop="company"
            style="margin-bottom: 5px"
          >
            <a-select
              v-model="form.company"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleCompanyChange($event)"
            >
              <a-select-option
                v-for="item in this.info.my_company"
                :key="item.ID"
                >{{ item.TITLE }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data wystawienia')" prop="billingDate">
            <a-date-picker
              v-model="form.billingDate"
              type="date"
              :locale="locale"
              style="width: 100%"
              @change="handlebillingDate($event)"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccount">
            <a-col :span="12" style="width: 83%; margin-right: 5px">
              <a-dropdown :trigger="['click']">
                <a-input class="ant-dropdown-link" v-model="form.bankAccount" />
                <a-menu slot="overlay">
                  <a-menu-item
                    v-for="(item, index) in bankAccountList"
                    :key="index"
                    @click="
                      () => {
                        handleChangeSelectAccount(item);
                      }
                    "
                    >{{ item }}</a-menu-item
                  >
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-button
              type="primary"
              icon="plus"
              @click="
                () => {
                  addNewKonto();
                }
              "
              :size="size"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
            <a-date-picker
              v-model="form.saleDate"
              type="date"
              :format="YYYY - MM - DD"
              :locale="locale"
              @change="handleSaleDateChange"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
            <!-- <a-select
              v-model="form.contractor"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              @dropdownVisibleChange="companyUpdate"
              :filter-option="filterOption"
              @change="handleContractorChange($event)"
              style="width: 83%; margin-right: 5px"
            >
              <a-select-option
                v-for="(comp, id) in COMPANY_LIST"
                :key="id"
              >{{
                comp.TITLE
              }}</a-select-option>
            </a-select>-->
            <a-input
              style="width: 83%; margin-right: 5px"
              v-model="companyTitle"
              @click="handleContractorChange($event)"
            />
            <a-button
              @click="$refs.integrationNipModal.showModal()"
              type="primary"
              icon="plus"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data usługi')">
            <a-date-picker
              v-model="form.serviceDate"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Opiekun')">
            <a-select
              show-search
              option-filter-prop="children"
              v-model="Opiekun"
              :filter-option="filterOption"
              @change="handleUserChange($event)"
              style="width: 100%"
            >
              <a-select-option
                v-for="item in this.responsible"
                :key="item.ID"
                >{{ item.NAME + " " + item.LAST_NAME }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
            <a-date-picker
              v-model="form.dueDate"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Projekt')">
            <a-select
              v-model="form.project"
              placeholder="please select"
              show-search
              allowClear
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item in this.project" :key="item.ID">{{
                item.TITLE + " (" + item.ID + ")"
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
            <a-date-picker
              v-model="form.reminder"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
            <a-select
              v-model="form.invoiceType"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              default-value="Faktura"
              @change="handlerInvoiceType"
            >
              <a-select-option value="Faktura">{{
                $t("Faktura Kosztowa")
              }}</a-select-option>
              <a-select-option value="Proforma">{{
                $t("Proforma")
              }}</a-select-option>
              <a-select-option value="VAT Marza">{{
                $t("Faktura do Proformy")
              }}</a-select-option>
              <a-select-option value="Korekta">{{
                $t("Korygująca")
              }}</a-select-option>
              <a-select-option value="Faktura zaliczkowa">{{
                $t("Faktura zaliczkowa")
              }}</a-select-option>
              <a-select-option value="Faktura koncowa">{{
                $t("Faktura koncowa")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-item
            v-if="
              ['Prepayment', 'Correction'].includes(selectInvoiceCorrection)
            "
          >
            <template slot="label">
              <span v-if="selectInvoiceCorrection == 'Correction'">{{
                $t("Corrected document")
              }}</span>
              <span v-if="selectInvoiceCorrection == 'Prepayment'">{{
                $t("Prepayment document")
              }}</span>
            </template>
            <div style="display: flex">
              <a-select
                showSearch
                v-model="form.invoiceCorrection"
                optionFilterProp="children"
                @change="handlerInvoiceCorrection"
              >
                <a-select-option
                  v-for="itm in invoiceCorrectionVaribl"
                  :key="itm.ID"
                  >{{ itm.invoiceTitle }}</a-select-option
                >
              </a-select>
              <a-button
                v-if="Object.keys(this.sale_record)"
                @click="showDrawer"
                type="link"
                icon="eye"
              />
            </div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Płatność')" prop="paymentType">
            <a-select
              v-model="form.paymentType"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              default-value="Przelew"
            >
              <a-select-option key="Gotówka">{{
                $t("Gotówka")
              }}</a-select-option>
              <a-select-option key="Przelew">{{
                $t("Przelew")
              }}</a-select-option>
              <a-select-option key="Karta">{{ $t("Karta") }}</a-select-option>
              <a-select-option key="Pobranie">{{
                $t("Pobranie")
              }}</a-select-option>
              <a-select-option key="Kompensata">{{
                $t("Kompensata")
              }}</a-select-option>
              <a-select-option key="Barter">{{ $t("Barter") }}</a-select-option>
              <a-select-option key="Płatność przez Pracownika">{{ $t("Płatność przez Pracownika") }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Opis')" prop="description">
            <a-input v-model="form.description" type="textarea" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-select
                  v-model="form.currency"
                  placeholder="please select"
                  @change="handleCurrencyChange($event)"
                >
                  <a-select-option
                    v-for="itemCurr in currencyValues"
                    :key="itemCurr"
                    >{{ itemCurr }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-input v-model="form.course" disabled />
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Język')">
            <a-select
              v-model="form.language"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option value="Polski">{{
                $t("Polskie")
              }}</a-select-option>
              <a-select-option value="Język angielski">{{
                $t("Język angielski")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="{ 'show-size-changer': true }"
          bordered
          tableLayout="auto"
          :scroll="{ x: true }"
          prop="table"
          style="margin-top: 10px"
        >
          <template slot="name" slot-scope="text, record">
            <a-tree-select
              v-if="record.editable"
              show-search
              style="width: 100%"
              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
              :tree-data="productTreeBySection"
              placeholder="Please select"
              treeNodeFilterProp="title"
              @select="
                (id, node) =>
                  handleChangeSelectProduct(node.dataRef, record.key, 'name')
              "
            >
            </a-tree-select>
            <template v-else>{{ text }}</template>
          </template>

          <template slot="units" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a rate"
              :value="text"
              @change="(e) => handleChange(e, record.key, 'units')"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in MEASURE_LIST"
                :key="item.symbolLetterIntl"
                >{{ item.symbolLetterIntl }}</a-select-option
              >
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template slot="vat_rate" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a rate"
              @change="(e) => handleChange(e, record.key, 'vat_rate')"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              :default-value="0"
            >
              <a-select-option v-for="(item, index) in VAT_LIST" :key="index">{{
                item.NAME
              }}</a-select-option>
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template slot="type_arrival" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a type"
              :value="text"
              @change="(e) => handleChange(e, record.key, 'type_arrival')"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in user_setup.RodzajPrzychodu"
                :key="item"
                >{{ item }}</a-select-option
              >
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template
            v-for="col in ['unit_price', 'quantity']"
            :slot="col"
            slot-scope="text, record"
          >
            <div :key="col">
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="(e) => handleChange(e.target.value, record.key, col)"
              />
              <template v-else>{{ text }}</template>
            </div>
          </template>

          <template slot="operation" slot-scope="text, record">
            <a-row class="editable-row-operations" style="text-align: center">
              <span v-if="record.editable">
                <a-col :span="12">
                  <a
                    :disabled="
                      !record.name || !record.Netto || !record.quantity
                    "
                    @click="() => saveTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="save"
                    />
                  </a>
                </a-col>
                <a-col :span="12">
                  <a @click="() => cancelTable(record.key)">
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="stop"
                      theme="twoTone"
                    />
                  </a>
                </a-col>
              </span>
              <span v-else>
                <a-col :span="12">
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => editTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="edit"
                    />
                  </a>
                </a-col>
                <a-col :span="12">
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => deleteTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="delete"
                    />
                  </a>
                </a-col>
              </span>
            </a-row>
          </template>
        </a-table>
        <a-button type="primary" class="editable-add-btn" @click="handleAdd">{{
          $t("Dodaj")
        }}</a-button>
      </a-row>
    </a-form-model>
    <a-drawer
      :title="correctDATA.invoiceTitle"
      placement="right"
      :visible="visible"
      :width="900"
      :after-visible-change="afterVisibleChange"
      @close="onCloseDrawer"
    >
      <a-form
        id="my_form_styl"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="width: 100%"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Spółka')" prop="company">
              {{ this.myCompanyCorrection }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('Data wystawienia')"
              prop="billingDate"
            >
              {{ correctDATA.billingDate }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
              {{ correctDATA.bankAccount }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
              {{ correctDATA.saleDate }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
              {{ this.contractorCorrection }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data usługi')">
              {{ correctDATA.serviceDate }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Opiekun')">
              {{
                this.userCorrection.NAME + " " + this.userCorrection.LAST_NAME
              }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
              {{ correctDATA.dueDate }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Projekt')">
              {{ this.DEALcorrection }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
              {{ correctDATA.reminder }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
              {{ correctDATA.invoiceType }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              v-if="
                this.correctDATA.invoiceCorrection != '' ||
                this.correctDATA.correctionBack != ''
              "
              :label="$t('Korekta')"
            >
              {{ invTitleifSalerec }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Payment')" prop="paymentType">
              {{ correctDATA.paymentType }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Opis')">
              {{ correctDATA.description }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
              <a-row :gutter="16">
                <a-col :span="12">
                  {{ correctDATA.currency }}
                </a-col>
                <a-col :span="12">
                  {{ this.currencyAmoutCorrection }}
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Język')">
              {{ correctDATA.language }}
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-table
            :columns="columns"
            tableLayout="auto"
            :scroll="{ x: true }"
            :data-source="dataSourceCorrection"
            :pagination="{ hideOnSinglePage: true }"
            bordered
          ></a-table>
        </a-row>
      </a-form>
    </a-drawer>
  </a-row>
</template>
<script>
import moment from "moment";
import {
  requestStep,
  getInvoiceSalesCorrection,
  getCurrency,
} from "@/requestFunc";
import integrationNipModal from "@/components/integrationNipModal";
import locale from "ant-design-vue/es/date-picker/locale/pl_PL";
import { mapGetters } from "vuex";

export default {
  props: [
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "sale_record",
    "user_setup",
    "DEAL",
  ],
  components: { integrationNipModal },
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data() {
    return {
      locale,
      columns: [
        {
          title: this.$t("Nazwa produktu"),
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("Jednostka"),
          dataIndex: "units",
          scopedSlots: { customRender: "units" },
        },
        {
          title: this.$t("Rodzaj przychodu"),
          dataIndex: "type_arrival",
          scopedSlots: { customRender: "type_arrival" },
        },
        {
          title: this.$t("Stawka VAT"),
          dataIndex: "vat_rate",
          scopedSlots: { customRender: "vat_rate" },
        },
        {
          title: this.$t("Ilość"),
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: this.$t("Cena"),
          dataIndex: "unit_price",
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: this.$t("Netto"),
          dataIndex: "Netto",
        },
        {
          title: this.$t("Vat"),
          dataIndex: "Vat",
        },
        {
          title: this.$t("Brutto"),
          dataIndex: "Brutto",
        },
        {
          title: this.$t("Operacje"),
          dataIndex: "operation",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ],
      currencyAmout: "",
      currencyAmoutCorrection: "",
      myCompanyCorrection: "",
      contractorCorrection: "",
      dataSourceCorrection: [],
      userCorrection: [],
      DEALcorrection: "",
      invTitleifSalerec: "",
      selectInvoiceCorrection: "",
      invoiceCorrectionVaribl: [],
      domain: null,
      dataSource: [],
      checkNull: 0,
      cacheData: [],
      currencyDate: "",
      Opiekun: "",
      companyTitle: "",
      payDay: "",
      visible: false,
      editingKey: "",
      bankAccountList: [],
      SECTION_LIST: [],
      productTreeBySection: [],
      PRODUCT_LIST: [],
      DEAL_LIST: [],
      MEASURE_LIST: [],
      currencyValues: [],
      responsible: [],
      project: [],
      nettoVal: 0,
      vatVal: 0,
      bruttoVal: 0,
      correctDATA: [],
      update: {},
      statuGoSteps: {},
      allData: {},
      form: {
        ID: "",
        company: "",
        bankAccount: "",
        contractor: "",
        responsible: "",
        project: "",
        invoiceType: "",
        paymentType: "",
        course: "",
        currency: "",
        language: "",
        description: "",
        positions: [],
        billingDate: "",
        dueDate: "",
        serviceDate: "",
        saleDate: "",
        reminder: "",
        invoiceCorrection: "",
        correctionBack: "",
      },
      rules: {
        currency: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        paymentType: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        invoiceType: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        contractor: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        bankAccaunt: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        serviceDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        saleDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        dueDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        billingDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        table: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    moment,
    afterVisibleChange() {},
    showDrawer() {
      this.visible = true;
    },
    onCloseDrawer() {
      this.visible = false;
    },
    companyUpdate(open) {
      if (open) {
        BX24.callMethod(
          "crm.company.list",
          {
            filter: {
              ">ID": this.info.company[this.info.company.length - 1].ID,
            },
            select: ["ID", "TITLE", this.companyFieldForNIP, "ASSIGNED_BY_ID"],
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              let res = result.data();
              this.info.company = this.info.company.concat(res);
              if (result.more()) result.next();
            }
          }
        );
      }
    },
    handlerNipClose(companyID) {
      if (companyID) {
        if (this.COMPANY_LIST[companyID]) {
          let id = companyID.toString();
          this.form.contractor = id;
          this.handleContractorChange(id);
        } else {
          BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
            if (result.error()) console.error(result.error());
            else {
              let companyInfo = result.data();
              this.COMPANY_LIST = Object.assign({}, this.COMPANY_LIST, {
                [companyID]: companyInfo,
              });
              this.form.contractor = companyInfo.ID;
              this.handleContractorChange(companyInfo.ID);
            }
          });
        }
      }
    },
    handleCompanyChange(event) {
      this.bankAccountList = this.info.my_company.filter((el) => {
        if (el.ID == event) return el;
      })[0].UF_CRM_BANK_ACCOUNT;
      this.form.bankAccount = this.bankAccountList[0];
    },
    handleChangeSelectAccount(item) {
      this.form.bankAccount = item;
    },
    handleUserChange(event) {
      this.form.responsible = event;
    },
    handleContractorChange() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          //company = info.company[0].id.split("_")[1];
          this.form.contractor = info.company[0].id.split("_")[1];

          this.companyTitle = info.company[0].title;
          this.form.project = "";

          BX24.callMethod(
            "crm.deal.list",
            { filter: { COMPANY_ID: this.form.contractor } },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                this.project = result.data();
              }
            }
          );

          /* this.project = this.DEAL_LIST.filter(
              (el) => el.COMPANY_ID == event || el.ID == this.dataSales.id
            );*/
          /* this.companyContractor =
              this.info.company.find((el) => el.ID == event) || {};*/

          /* this.responsible = this.info.data_user.filter((el) => {
              if (
                el.ID == this.dataSales.opiekunCS ||
                el.ID == this.companyContractor.ASSIGNED_BY_ID ||
                this.user_setup.responsibleSpredz.includes(el.ID) ||
                this.user_setup.responsibleAll.includes(el.ID)
              )
                return el;
            });*/

          /* let search = this.checkMedia
              ? this.dataSales.opiekunCSect = this.dataSales.id;
            var findOpiekun = this.info.data_user.find((el) => el.ID == search);
            if (findOpiekun) {
              : this.companyContractor.ASSIGNED_BY_ID;
            if (this.checkMedia) this.form.projeect = this.dataSales.id;
            var findOpiekun = this.info.data_user.findect = this.dataSales.id;
            var findOpiekun = this.info.data_user.find((el) => el.ID == search);
            if (findOpiekun) {((el) => el.ID == search);
            if (findOpiekun) {
              this.Opiekun = findOpiekun.ID;
              this.form.responsible = findOpiekun.ID;
            } else {
              this.Opiekun = "";
              this.form.responsible = "";
            }*/

          BX24.callMethod(
            "crm.company.get",
            { id: this.form.contractor },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                var companyInfo = result.data();
                //this.payDay = this.info.company.find((el) => event == el.ID) || {};
                if (companyInfo[this.user_setup.termin]) {
                  this.form.dueDate = moment().add(
                    companyInfo[this.user_setup.termin],
                    "days"
                  );
                }

                let userArray = [];
                let usersArray = userArray.concat(
                  this.dataSales.opiekunCS,
                  companyInfo.ASSIGNED_BY_ID,
                  this.user_setup.responsibleSpredz,
                  this.user_setup.responsibleAll
                );

                BX24.callMethod("user.get", { id: usersArray }, (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.responsible = result.data();
                  }
                });
              }
            }
          );

          /*this.payDay = this.info.company.find((el) => event == el.ID) || {};
            if (this.payDay[this.user_setup.termin]) {
              this.form.dueDate = moment().add(
                this.payDay[this.user_setup.termin],
                "days"
              );
            }*/
        }
      );
    },
    handlerInvoiceType(e) {
      var kontragent = this.form.contractor || this.sale_record.contractor;
      var my_company = this.form.company || this.sale_record.company;
      var invoiceID = this.sale_record.ID;

      if (!Object.keys(this.sale_record)) {
        this.form.ID = 0;
      } else {
        this.form.ID = this.sale_record.ID;
      }
      if (my_company && kontragent) {
        if (e == "Korekta") {
          getInvoiceSalesCorrection({
            type: "Correction",
            current_id: this.form.ID,
            my_company,
            kontragent,
          }).always((res) => {
            let data = JSON.parse(res);

            this.invoiceCorrectionVaribl = data;
            this.selectInvoiceCorrection = "Correction";
          });
        } else if (e == "Faktura koncowa") {
          getInvoiceSalesCorrection({
            type: "Prepayment",
            current_id: this.form.ID,
            my_company,
            kontragent,
            invoiceID,
          }).always((res) => {
            let data = JSON.parse(res);

            this.invoiceCorrectionVaribl = data;
            this.selectInvoiceCorrection = "Prepayment";
          });
        } else if (e == "Faktura zaliczkowa" || e == "Faktura") {
          getInvoiceSalesCorrection({
            type: "favzal",
            current_id: this.form.ID,
            my_company,
            kontragent,
          }).always((res) => {
            let data = JSON.parse(res);

            this.invoiceCorrectionVaribl = data;
            this.selectInvoiceCorrection = "Correction";
          });
        } else {
          this.selectInvoiceCorrection = "";
        }
      } else {
        this.selectInvoiceCorrection = "";
      }
    },
    handlerInvoiceCorrection() {
      /* let tables = this.invoiceCorrectionVaribl[e].invoiceTable;
      for (let table in tables) {
        for (let item in tables[table].sum_distribution) {
          if (tables[table].sum_distribution[item]["accept"]) {
            tables[table].sum_distribution[item]["accept"].status = false;
          }
        }
      }
      this.document.invoiceTable = tables;
      this.document.Quota = this.invoiceCorrectionVaribl[e].Quota;*/
    },
    preview() {
      /*  var invCorrec = this.form.getFieldValue("invoiceCorrection");
      if (invCorrec >= 0) {
        this.$emit("showPreview", this.invoiceCorrectionVaribl[invCorrec]);
      }*/
    },
    handleCurrencyChange(event) {
      /* this.form.course = this.info.currency.filter(el => {
        if (el.CURRENCY == event) return el;
      })[0].AMOUNT;*/

      var curr = this.info.currency.find((x) => x.CURRENCY == event);
      if (!this.currencyDate || curr?.CURRENCY == "PLN") {
        this.form.course = curr.AMOUNT;
      } else {
        this.form.currency = curr?.CURRENCY;
        this.handleSaleDateChange();
      }
    },
    handleSaleDateChange(e) {
      let code = this.form.currency;
      let date = e ? e : moment(this.form.saleDate);

      if (date) {
        //date = moment(date).subtract(1, "days");
        //date = moment("2020-7-13").format("YYYY-MM-DD");
        date = moment(date).subtract(1, "days");
        this.currencyDate =
          date.isoWeekday() > 5
            ? date.subtract(date.isoWeekday() - 5, "days").format("YYYY-MM-DD")
            : date.format("YYYY-MM-DD");

        if (code != "PLN") {
          getCurrency({ code, date: this.currencyDate }).done((data) => {
            let res = JSON.parse(data);
            if (res) {
              if (res.currency) {
                this.form.course = res.rates[0]["mid"];
                this.$message.success(this.$t("Currency updated"));
              }
            }
          });
        }
      }
    },
    onSubmit(updateStatus) {
      this.$refs.form.validate((valid) => {
        this.changeSpinning();
        if (valid) {
          let format_moment = (date) =>
            date ? moment(date).format("YYYY-MM-DD") : "";

          this.form.billingDate = format_moment(this.form.billingDate);
          this.form.dueDate = format_moment(this.form.dueDate);
          this.form.serviceDate = format_moment(this.form.serviceDate);
          this.form.saleDate = format_moment(this.form.saleDate);
          this.form.reminder = format_moment(this.form.reminder);
          if (Object.keys(this.sale_record)) {
            this.form.correctionBack = this.sale_record.ID;
            this.form.ID = this.sale_record.ID;
          } else {
            this.form.ID = 0;
          }
          this.form.positions = this.dataSource;
          this.form["run"] = "createSaleAndSaveStageOne";
          this.form["updateStatus"] = updateStatus;
          requestStep(this.allData, "./php/request.php")
            .done((data) => {
              let res = JSON.parse(data);
              if (res.status == "error") {
                this.$message.error(this.$t("Błąd podczas tworzenia konta"));
              } else {
                let prev = this.sale_record.status;
                this.sale_record = Object.assign(this.sale_record, res.data);

                if (updateStatus == true) {
                  this.onClose({ prev, next: status });
                  this.goSteps(this.sale_record);
                } else {
                  this.$emit("generatrDoc", res.docID);
                }

                this.$message.success(this.$t("Tworzenie faktury zakończone!"));
              }
            })
            .always(() => {
              this.changeSpinning();
            });
        } else {
          this.changeSpinning();
          return false;
        }
      });
    },
    /*saveValues() {
      let data = {
        run: "createSaleAndSaveStageOne",
      };

      if (this.sale_record == null || this.sale_record == "") {
        for (let key in this.form) {
          this.form[key] = {
            old: "",
            new: this.form[key],
          };
        }
      } else {
        for (let key in this.form) {
          if (
            key in this.sale_record &&
            this.form[key] != this.sale_record[key]
          ) {
            this.form[key] = {
              old: this.sale_record[key],
              new: this.form[key],
            };
          } else {
            delete this.form[key];
          }
        }
      }
      Object.assign(data, this.form);
      this.$emit("checkPositionFunc", this.dataSource);
      return data;
    },*/
    saveValues() {
      let dataFL = {
        run: "createSaleAndSaveStageOne",
        positions: this.dataSource,
      };
      let datanew = {};
      if (Object.keys(this.sale_record)) {
        dataFL["ID"] = this.sale_record.ID;
      } else {
        dataFL["ID"] = 0;
      }
      /* let update = {
        PaymentDateReal: values.PaymentDateReal
          ? moment(values.PaymentDateReal).format("YYYY-MM-DD")
          : ""
      };*/
      Object.assign(datanew, this.form);
      if (!Object.keys(this.sale_record)) {
        for (let key in datanew) {
          datanew[key] = {
            old: "",
            new: datanew[key],
          };
        }
      } else {
        for (let key in datanew) {
          if (
            key in this.sale_record &&
            datanew[key] != this.sale_record[key]
          ) {
            datanew[key] = {
              old: this.sale_record[key],
              new: datanew[key],
            };
          } else {
            delete datanew[key];
          }
        }
      }
      delete datanew.ID;
      delete datanew.positions;
      Object.assign(dataFL, datanew);
      this.$emit("checkPositionFunc", this.dataSource);
      return dataFL;
    },
    handleAdd() {
      for (let i in this.dataSource) {
        if (this.dataSource[i]["editable"]) {
          if (this.dataSource[i].namefield && this.dataSource[i].koszty) {
            this.saveTable(this.dataSource[i].key);
            break;
          } else {
            return;
          }
        }
      }
      const newData = {
        key: this.dataSource.length,
        name: "",
        units: "Szt",
        vat_rate: "23",
        quantity: "",
        unit_price: "",
        Brutto: 0,
        Vat: 0,
        Netto: 0,
        type_arrival: "",
        editable: true,
      };
      this.dataSource = [...this.dataSource, newData];
      this.editingKey = newData.key;
      this.cacheData = this.dataSource.map((item) => ({
        ...item,
      }));
      this.$emit("checkPositionFunc", this.dataSource);
    },
    addNewKonto() {
      if (Array.isArray(this.bankAccountList)) {
        if (!this.bankAccountList.includes(this.form.bankAccount)) {
          this.bankAccountList.push(this.form.bankAccount);

          BX24.callMethod(
            "crm.company.update",
            {
              id: this.form.company,
              fields: {
                UF_CRM_BANK_ACCOUNT: this.bankAccountList,
              },
            },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                this.$message.success(this.$t("Dodano nowe konto bankowe!"));
                console.info(result.data());
              }
            }
          );
        } else {
          this.$message.warning(this.$t("Takie konto bankowe już istnieje!"));
        }
      } else {
        this.bankAccountList = [this.form.bankAccount];

        BX24.callMethod(
          "crm.company.update",
          {
            id: this.form.company,
            fields: {
              UF_CRM_BANK_ACCOUNT: this.bankAccountList,
            },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.$message.success(this.$t("Dodano nowe konto bankowe!"));
              console.info(result.data());
            }
          }
        );
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        if (column == "vat_rate") {
          target[column] = this.VAT_LIST[value]["RATE"];
        } else {
          target[column] = value;
        }

        this.dataSource = newData;

        if (
          column == "vat_rate" ||
          column == "quantity" ||
          column == "unit_price"
        ) {
          target.Netto = !isNaN(target.quantity * target.unit_price)
            ? target.quantity * target.unit_price
            : 0;
          target.Vat = !isNaN((target.Netto * target.vat_rate) / 100)
            ? (target.Netto * target.vat_rate) / 100
            : 0;
          target.Brutto = !isNaN(target.Vat + target.Netto)
            ? target.Vat + target.Netto
            : 0;
          target.Netto = target.Netto.toFixed(2);
          target.Vat = target.Vat.toFixed(2);
          target.Brutto = target.Brutto.toFixed(2);
        }
      }
      this.$emit("checkPositionFunc", this.dataSource);
    },
    handleChangeSelectProduct(product, key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target["productID"] = product.value;
        target["name"] = product.title;
        //target["units"] = product["MEASURE"];
        // TODO product vat
        // target["vat_rate"] = this.VAT_LIST.find(x => x.ID == product["VAT_ID"]);
        target["unit_price"] = product.price;
        this.dataSource = newData;
        this.handleChange(product.title, key, "name");
      }
    },
    deleteTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter((item) => item.key !== key);

      for (let item of this.dataSource) {
        this.nettoVal += item.Netto * 1;
        this.vatVal += item.Vat * 1;
        this.bruttoVal += item.Brutto * 1;
      }
      this.nettoVal = this.nettoVal.toFixed(2);
      this.vatVal = this.vatVal.toFixed(2);
      this.bruttoVal = this.bruttoVal.toFixed(2);
      this.form.positions = this.dataSource;
      this.sale_record.netto = this.nettoVal;
      this.sale_record.vat = this.vatVal;
      this.sale_record.totalAmout = this.bruttoVal;
      this.$emit("checkPositionFunc", this.dataSource);
    },
    editTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;

      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        for (let item of newData) {
          this.nettoVal += item.Netto * 1;
          this.vatVal += item.Vat * 1;
          this.bruttoVal += item.Brutto * 1;
        }
        this.nettoVal = this.nettoVal.toFixed(2);
        this.vatVal = this.vatVal.toFixed(2);
        this.bruttoVal = this.bruttoVal.toFixed(2);
        target.editable = true;
        this.dataSource = newData;
      }
      this.sale_record.netto = this.nettoVal;
      this.sale_record.vat = this.vatVal;
      this.sale_record.totalAmout = this.bruttoVal;
      this.form.positions = this.dataSource;
      this.$emit("checkPositionFunc", this.dataSource);
    },
    saveTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;
      // TODO высчитывать ват нетто брутоо
      const newData = [...this.dataSource];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.dataSource = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        for (let item of newData) {
          this.nettoVal += item.Netto * 1;
          this.vatVal += item.Vat * 1;
          this.bruttoVal += item.Brutto * 1;
        }
        this.nettoVal = this.nettoVal.toFixed(2);
        this.vatVal = this.vatVal.toFixed(2);
        this.bruttoVal = this.bruttoVal.toFixed(2);
      }
      this.editingKey = "";
      this.form.positions = this.dataSource;

      this.sale_record.netto = this.nettoVal;
      this.sale_record.vat = this.vatVal;
      this.sale_record.totalAmout = this.bruttoVal;
      this.$emit("checkPositionFunc", this.dataSource);
    },
    handlebillingDate(event) {
      if (this.payDay != null && this.payDay != "") {
        let format_moment = (date) =>
          date ? moment(date).format("YYYY-MM-DD") : "";
        let d = format_moment(event);
        let finD = new Date(d);
        // let d = format_moment(event);

        // var editTime = finD.setDate(finD.getDate() + Number(this.payDay));
        var curr_date = finD.getDate();
        var curr_month = finD.getMonth();
        var curr_year = finD.getFullYear();
        this.form.dueDate = curr_year + "-" + curr_month + "-" + curr_date;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    cancelTable(key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCach = this.cacheData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target && targetCach.name && targetCach.Netto) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.dataSource = newData;
      } else {
        this.deleteTable(key);
      }
      this.$emit("checkPositionFunc", this.dataSource);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    onClose(element) {
      this.$emit("onClose", element);
    },
    goSteps(record) {
      //this.statuGoSteps = { status: "Oczekujący", ID: ID };
      this.$emit("goSteps", record);
    },
  },
  mounted() {
    this.allData = this.saveValues();

    //this.handleCompanyChange(this.form.company);
    this.form.invoiceType = "Faktura";
    this.form.paymentType = "Przelew";
    this.form.language = "Polski";

    let dat = new Date();
    var curr_date_mou = dat.getDate();
    var curr_month_mou = dat.getMonth() + 1;
    var curr_year_mou = dat.getFullYear();
    var curr_date_mou_for = dat.getDate() - 1;
    var curr_month_mou_for = dat.getMonth() + 1;
    var curr_year_mou_for = dat.getFullYear();
    let forCurrency =
      curr_year_mou_for + "-" + curr_month_mou_for + "-" + curr_date_mou_for;
    this.form.billingDate =
      curr_year_mou + "-" + curr_month_mou + "-" + curr_date_mou;
    this.form.saleDate =
      curr_year_mou + "-" + curr_month_mou + "-" + curr_date_mou;
    this.currencyDate = forCurrency;
    if (Object.keys(this.sale_record).length != 0) {
      this.nettoVal = this.sale_record.netto;
      this.vatVal = this.sale_record.vat;
      this.bruttoVal = this.sale_record.totalAmout;
      this.invTitleifSalerec = this.sale_record.invoiceTitle;
      let kk = this.sale_record.allCompany.find((el) => {
        if (this.sale_record.contractor == el.ID) return el;
      });
      this.payDay = kk ? kk[this.user_setup.termin] : "";
      this.dataSource = this.sale_record.positions;
      this.form.positions = this.dataSource;
      this.form.currency = this.sale_record.currency;
      this.cacheData = this.dataSource;
      this.handlerInvoiceType(this.sale_record.invoiceType);
      this.handleCurrencyChange(this.sale_record.currency);

      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.invoiceCorrection },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.invoiceCorrectionVaribl = this.invoiceCorrectionVaribl.concat(
              result.data()[0]["PROPERTY_VALUES"]
            );
          }
        }
      );

      if (this.sale_record.invoiceCorrection != "") {
        this.form.invoiceCorrection = this.sale_record.invoiceCorrection;
      } else if (this.sale_record.correctionBack != "") {
        this.form.invoiceCorrection = this.sale_record.correctionBack;
      }

      /* this.project = this.DEAL.filter((el) => {
        if (el.COMPANY_ID == this.sale_record.contractor) return el;
      });*/

      BX24.callMethod(
        "crm.deal.list",
        { filter: { COMPANY_ID: this.sale_record.contractor } },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.project = result.data();
          }
        }
      );

      this.companyContractor =
        this.sale_record.allCompany.find(
          (el) => el.ID == this.sale_record.contractor
        ) || {};

      this.companyTitle = this.companyContractor.TITLE;
      this.form.contractor = this.companyContractor.ID;

      let userArray = [];
      let usersArray = userArray.concat(
        this.companyContractor.ASSIGNED_BY_ID,
        this.user_setup.responsibleSpredz,
        this.user_setup.responsibleAll
      );

      BX24.callMethod("user.get", { id: usersArray }, (result) => {
        if (result.error()) console.error(result.error());
        else {
          this.responsible = result.data();
        }
      });

      /*
      this.responsible = this.info.data_user.filter((el) => {
        if (
          el.ID == this.companyContractor.ASSIGNED_BY_ID ||
          this.user_setup.responsibleSpredz.includes(el.ID) ||
          this.user_setup.responsibleAll.includes(el.ID)
        )
          return el;
      });*/
      let ll = this.sale_record.userInfo.find((el) => {
        if (el.ID == this.sale_record.responsible) return el;
      });
      this.Opiekun = ll?.ID;

      this.form.responsible = this.Opiekun;

      let arrayFields = [
        "company",
        "bankAccount",
        "contractor",
        "invoiceType",
        "paymentType",
        "currency",
        "project",
        "language",
        "description",
        "billingDate",
        "dueDate",
        "serviceDate",
        "saleDate",
        "reminder",
      ];
      for (let item of arrayFields) {
        this.form[item] = this.sale_record[item];
      }

      if (this.sale_record.invoiceCorrection) {
        BX24.callMethod(
          "entity.item.get",
          {
            ENTITY: "invoices",
            FILTER: { ID: this.sale_record.invoiceCorrection },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
                "invoiceTitle"
              ];
              this.correctDATA = result.data()[0]["PROPERTY_VALUES"];

              this.dataSourceCorrection = JSON.parse(
                this.correctDATA.positions
              );
              this.currencyAmoutCorrection = this.info.currency.filter((el) => {
                if (this.correctDATA.currency == el.CURRENCY) return el;
              })[0].AMOUNT;

              this.myCompanyCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.company == el.ID) return el;
              })[0].TITLE;

              this.contractorCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.contractor == el.ID) return el;
              })[0].TITLE;

              this.userCorrection = this.info.data_user.filter((el) => {
                if (this.correctDATA.responsible == el.ID) return el;
              })[0];

              BX24.callMethod(
                "crm.deal.get",
                { id: this.correctDATA.project },
                (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.DEALcorrection = result.data()["TITLE"];
                  }
                }
              );
            }
          }
        );
      } else if (this.sale_record.correctionBack) {
        BX24.callMethod(
          "entity.item.get",
          {
            ENTITY: "invoices",
            FILTER: { ID: this.sale_record.correctionBack },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
                "invoiceTitle"
              ];
              this.correctDATA = result.data()[0]["PROPERTY_VALUES"];

              this.dataSourceCorrection = JSON.parse(
                this.correctDATA.positions
              );
              this.currencyAmoutCorrection = this.info.currency.filter((el) => {
                if (this.correctDATA.currency == el.CURRENCY) return el;
              })[0].AMOUNT;

              this.myCompanyCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.company == el.ID) return el;
              })[0].TITLE;

              this.contractorCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.contractor == el.ID) return el;
              })[0].TITLE;

              this.userCorrection = this.info.data_user.filter((el) => {
                if (this.correctDATA.responsible == el.ID) return el;
              })[0];

              BX24.callMethod(
                "crm.deal.get",
                { id: this.correctDATA.project },
                (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.DEALcorrection = result.data()["TITLE"];
                  }
                }
              );
            }
          }
        );
      }
    } else {
      this.form.currency = "PLN";
      this.handleCurrencyChange(this.form.currency);
    }
    //this.handleChange(0, 0, "vat_rate");
    /* this.contractorFilter = this.info.company.filter(el => {
      if (this.sale_record.currency == el.CURRENCY) return el;
    })[0].AMOUNT;*/

    let auth = BX24.getAuth();
    this.domain = auth.domain;

    this.myCompany = this.info.my_company.map((el) => {
      return el;
    });

    this.currencyValues = this.info.currency.map((el) => {
      return el.CURRENCY;
    });
    //this.form.currency = "PLN";
    //this.handleCurrencyChange(this.form.currency);
    /*
    BX24.callMethod(
      "crm.deal.list",
      { select: ["ID", "TITLE", "COMPANY_ID"] },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          this.DEAL_LIST = this.DEAL_LIST.concat(result.data());
         
          if (result.more()) result.next();
        }
      }
    );*/

    BX24.callMethod("catalog.measure.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        this.MEASURE_LIST = this.MEASURE_LIST.concat(result.data().measures);
      }
    });

    BX24.callMethod(
      "crm.productsection.list",
      {
        filter: { CATALOG_ID: 27 },
        select: ["ID", "NAME"],
      },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          let sections = result.data();
          this.SECTION_LIST = this.SECTION_LIST.concat(sections);
          for (let section of sections) {
            this.productTreeBySection.push({
              title: section.NAME,
              value: section.ID,
              key: `section${section.ID}`,
              children: [],
            });
          }
          if (result.more()) result.next();
        }
      }
    );
    BX24.callMethod("crm.product.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        let products = result.data();
        this.PRODUCT_LIST = this.PRODUCT_LIST.concat(products);
        for (let i in this.SECTION_LIST) {
          this.productTreeBySection[i].children.push(
            ...products
              .filter((x) => x.SECTION_ID == this.SECTION_LIST[i].ID)
              .map((x) => {
                return {
                  title: x.NAME,
                  value: x.ID,
                  key: `product${x.ID}`,
                  price: x.PRICE,
                };
              })
          );
        }

        if (result.more()) {
          result.next();
        }
      }
    });
    BX24.fitWindow();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.editable-add-btn {
  margin-top: 8px;
}
#salesform .ant-form-item {
  margin-bottom: 0 !important;
}
#salesform .ant-form-item-control,
#salesform .ant-form-item-control-wrapper,
#salesform .ant-form-item-label {
  padding: 0;
}
</style>